<script setup lang="ts">
    import { Check } from 'lucide-vue-next';
    import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const props = defineProps<{
        selectedVouchers: Voucher[];
    }>();

    const isValidVoucher = (voucher: Voucher) =>
        !voucher.uploaded && (voucher.has_voucher || voucher.is_valid_no_file);

    const validVouchers = computed(() => props.selectedVouchers.filter(isValidVoucher));

    const invalidVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => !isValidVoucher(voucher)),
    );

    const approve = () => {
        if (invalidVouchers.value.length) {
            toast.error(t('vouchers.select.upload.invalid_header'), {
                description: t('vouchers.select.upload.invalid_description', {
                    body: invalidVouchers.value
                        .map((voucher) => `#${voucher.VoucherNumber}`)
                        .join(', '),
                }),
            });
            return;
        }

        voucherStore.setValidVouchers(validVouchers.value);
        voucherStore.toggleOpen('approve', true);
    };
</script>

<template>
    <DropdownMenuItem @click="approve">
        {{ t('vouchers.select.approve') }}
        <Check class="text-accent" />
    </DropdownMenuItem>
</template>
